/**
 * Порог нормы для определения превышения
 * Re-export из общих констант
 */
export { NORMAL_THRESHOLD } from "../../../constants/riskConfig";

export const CHART_LEGEND_ITEMS = {
  normal: { color: "bg-blue-500", key: "label-within-normal" },
  exceeds: { color: "bg-red-500", key: "label-exceeds-normal" },
} as const;
